<template>
  <section v-if="data" class="photos-gallery mt-5 pb-5">
    <Title class="photos-gallery-title" title="گالری تصاویر"></Title>
    <PhotosSlider v-if="data.images.length>0" :images="data.images" title="تصاویر نمونه کارها" titleResp="عکس ها" v-bind:icon-num="1" ></PhotosSlider>
        <div id="photosLinker" class="d-md-none text-center">
      <router-link to="/photos?type=main" class="gallery-more-btn bg-color-theme2 py-2 px-4 rounded-pill fontsize-small text-color-black weight-light">مشاهده همه</router-link>
    </div>
    <VideosSlider v-if="data.videos.length>0" :videos="data.videos" title="ویدئو نمونه کارها" titleResp="ویدئو ها" v-bind:icon-num="2" ></VideosSlider>
    <div  v-if="data.videos.length>0" class="d-md-none text-center">
      <router-link to="/videos?type=main" class="gallery-more-btn bg-color-theme2 py-2 px-4 rounded-pill fontsize-small text-color-black weight-light">مشاهده همه</router-link>
    </div>
  </section>
</template>

<script>
import Title from "./Title";
import PhotosSlider from "./PhotosSlider";
import VideosSlider from "./VideosSlider";
export default {
  name: "PhotosGallery",
  props:{
    data:Object
  },
  components:{
    Title,
    PhotosSlider,
    VideosSlider
  }
}
</script>

<style scoped>
.photos-gallery .photos-gallery-title{
  margin-bottom: 7rem;
}
.gallery-more-btn{
  box-shadow: 0 3px 3px #0003 , 0 3px 3px #0003 inset;
}
#photosLinker{
  margin: -25px auto 60px;
}
#photosLinker a{
  background-color:#30504f;
  color:white;
}
</style>